import React from "react";
import Svg, { Path } from "react-native-svg";

import { DietaryMark, type DietaryIconProps } from "./DietaryMark";

/** FSSAI non-veg mark — a red triangle in a red square, on its native 16×16 grid. */
export function NonVegIcon({ size = 14 }: DietaryIconProps) {
  return (
    <DietaryMark size={size} label="Non-vegetarian">
      <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
        <Path
          d="M12.2857 2H3.71429C2.76751 2 2 2.76751 2 3.71429V12.2857C2 13.2325 2.76751 14 3.71429 14H12.2857C13.2325 14 14 13.2325 14 12.2857V3.71429C14 2.76751 13.2325 2 12.2857 2Z"
          stroke="#C0392B"
          strokeWidth={1.3125}
        />
        <Path
          d="M7.10557 5.78885C7.4741 5.05181 8.5259 5.05181 8.89443 5.78885L11.2764 10.5528C11.6088 11.2177 11.1253 12 10.382 12H5.61803C4.87465 12 4.39116 11.2177 4.72361 10.5528L7.10557 5.78885Z"
          fill="#C0392B"
        />
      </Svg>
    </DietaryMark>
  );
}
NonVegIcon.displayName = "NonVegIcon";
export default NonVegIcon;
